"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var _this = this;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPLOY_MUTATION = exports.REFRESH_DATA_QUERY = exports.gql = exports.graphql = exports.FRAGMENTS = exports.TAXONOMY_EXPORT_FIELDS = exports.TAXONOMY_FIELDS = exports.PERMISSIONS_FIELDS = exports.CREATOR_FIELDS = exports.FILE_ASSET_VALUE_FIELDS = exports.FILE_UPDATE_FIELDS = exports.IMAGE_FIELDS = exports.IMAGE_UPDATE_FIELDS = exports.CONTENT_NODE_FIELDS = exports.CONTENT_NODE_UPDATE_FIELDS = exports.ENTITY_CORE_VALUE_FIELDS = exports.ENTITY_VALUE_FIELDS = exports.ENTITY_OPEN_GRAPH_FIELD = exports.ENTITY_SUMMARY_FIELDS = void 0;
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
exports.ENTITY_SUMMARY_FIELDS = "id name slug openGraph { id title image { id url } }";
exports.ENTITY_OPEN_GRAPH_FIELD = "openGraph { id title description { id text } image { id url thumbnails { id medium { id url } } } }";
exports.ENTITY_VALUE_FIELDS = "id name slug typeLabel isReadable openGraph { id title description { id text } image { id url thumbnails { id medium { id url } large { id url } } } }";
exports.ENTITY_CORE_VALUE_FIELDS = "id name slug";
exports.CONTENT_NODE_UPDATE_FIELDS = "id text";
exports.CONTENT_NODE_FIELDS = "\n  id text embeds { ".concat(exports.ENTITY_VALUE_FIELDS, " } atEmbeds { ").concat(exports.ENTITY_VALUE_FIELDS, " } linkEmbeds { ").concat(exports.ENTITY_VALUE_FIELDS, " _label url }\n");
exports.IMAGE_UPDATE_FIELDS = "id url formattedSize extension filename typeName thumbnails { id full { url width height } }";
exports.IMAGE_FIELDS = "id url thumbnails { id full { id url width height } }";
exports.FILE_UPDATE_FIELDS = "id url size type typeName formattedSize extension typeImage { id url } filename thumbnails { id small { id url } large { id url } }";
exports.FILE_ASSET_VALUE_FIELDS = "".concat(exports.ENTITY_VALUE_FIELDS, " type { ").concat(exports.ENTITY_VALUE_FIELDS, " } file { id url size type typeName typeImage { id url } formattedSize extension filename thumbnails { id small { id url } large { id url } } }");
exports.CREATOR_FIELDS = "id name slug hasAccount photo { id url thumbnails { id full { id url width height } } } organisation { id slug name }";
exports.PERMISSIONS_FIELDS = "id name slug permissionTypes { id name slug } grantedPerson { id name slug organisation { id name } photo { id url } location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }";
exports.TAXONOMY_FIELDS = "\n  challenges { ".concat(exports.ENTITY_VALUE_FIELDS, " }\n  keyIssues { ").concat(exports.ENTITY_VALUE_FIELDS, " }\n  topics { ").concat(exports.ENTITY_VALUE_FIELDS, " }\n  subTopics { ").concat(exports.ENTITY_VALUE_FIELDS, " }\n  trends { ").concat(exports.ENTITY_VALUE_FIELDS, " }\n");
exports.TAXONOMY_EXPORT_FIELDS = "\n  challenges { name }\n  keyIssues { name }\n  topics { name }\n  subTopics { name }\n  trends { name }\n";
exports.FRAGMENTS = {
  EntityValueFields: exports.ENTITY_VALUE_FIELDS,
  ContentNodeFields: exports.CONTENT_NODE_FIELDS,
  EntityCoreValueFields: exports.ENTITY_CORE_VALUE_FIELDS,
  ContentNodeUpdateFields: exports.CONTENT_NODE_UPDATE_FIELDS,
  ImageFields: exports.IMAGE_FIELDS,
  ImageUpdateFields: exports.IMAGE_UPDATE_FIELDS,
  FileUpdateFields: exports.FILE_UPDATE_FIELDS,
  FileAssetValueFields: exports.FILE_ASSET_VALUE_FIELDS,
  CreatorFields: exports.CREATOR_FIELDS,
  PermissionsFields: exports.PERMISSIONS_FIELDS,
  TaxonomyFields: exports.TAXONOMY_FIELDS,
  TaxonomyExportFields: exports.TAXONOMY_EXPORT_FIELDS
};
var graphql = function () {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var result = String.raw.apply(_this, args);
  // Replace recognised "fragment" syntax with the fragments above
  // This uses the ... syntax, but doesn't actually use GraphQL fragments, which are very problematic.
  // We're just using string replacement.
  var matches = (0, lodash_1.uniq)(result.match(/\.\.\.[A-Za-z_]+/ig) || []);
  var ret = matches.reduce(function (acc, m) {
    var fragment = exports.FRAGMENTS[m.replace("...", '')];
    if (!fragment) {
      console.warn("Unknown Fragment ".concat(m, " in query."));
    }
    return acc.replace(new RegExp(m, 'ig'), fragment || '__type');
  }, result);
  return ret;
};
exports.graphql = graphql;
var gql = function () {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  return (0, client_1.gql)(exports.graphql.apply(void 0, __spreadArray([], __read(args), false)));
};
exports.gql = gql;
exports.REFRESH_DATA_QUERY = (0, exports.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  { primeAll }\n"], ["\n  { primeAll }\n"])));
exports.DEPLOY_MUTATION = (0, exports.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["mutation { deploy }"], ["mutation { deploy }"])));
var templateObject_1, templateObject_2;